import React from "react";

import Svg, { Path } from "components/Svg";

const Signout = props => (
	<Svg
		width={15 * props.scale}
		height={15 * props.scale}
		viewBox="0 0 12 14"
	>
		<Path
			fill={props.fill || "black"}
			d="M5 11.25q0 0.031 0.008 0.156t0.004 0.207-0.023 0.184-0.078 0.152-0.16 0.051h-2.5q-0.93 0-1.59-0.66t-0.66-1.59v-5.5q0-0.93 0.66-1.59t1.59-0.66h2.5q0.102 0 0.176 0.074t0.074 0.176q0 0.031 0.008 0.156t0.004 0.207-0.023 0.184-0.078 0.152-0.16 0.051h-2.5q-0.516 0-0.883 0.367t-0.367 0.883v5.5q0 0.516 0.367 0.883t0.883 0.367h2.438t0.090 0.008 0.090 0.023 0.062 0.043 0.055 0.070 0.016 0.105zM12.25 7q0 0.203-0.148 0.352l-4.25 4.25q-0.148 0.148-0.352 0.148t-0.352-0.148-0.148-0.352v-2.25h-3.5q-0.203 0-0.352-0.148t-0.148-0.352v-3q0-0.203 0.148-0.352t0.352-0.148h3.5v-2.25q0-0.203 0.148-0.352t0.352-0.148 0.352 0.148l4.25 4.25q0.148 0.148 0.148 0.352z"
		/>
	</Svg>
);

export default Signout;



// WEBPACK FOOTER //
// ./src/components/svgs/Signout/index.js